import React from 'react';
import './SignUpText.css';
import GoogleLogIn from './GoogleLogIn';

// const mainStyle = {
//     textAlign : 'center',
//     background: '#E6F5EB',
//     opacity : 1.0,
//     width: '700px',
//     margin: 'auto',
//     borderSpacing:'0px',

// }

export default function App(props) {

  var GooglePart = <GoogleLogIn updateUserInfo={props.updateUserInfo} subdomainID={props.subdomainID} setExtraScreenSet={props.setExtraScreenSet}/>
//
    return (

          <table width="100%">
            <tbody>
              <tr>
                  {GooglePart}
              </tr>
            </tbody>
          </table>
    );
  
}

